// Service page components for reusable patterns
export { default as ServiceFeatureCard } from "./ServiceFeatureCard";
export { default as ServiceBenefitItem } from "./ServiceBenefitItem";
export { default as ServiceInfoBox } from "./ServiceInfoBox";
export { default as ServiceHeroImage } from "./ServiceHeroImage";
export { default as ServiceSection } from "./ServiceSection";
export { default as ServiceGrid } from "./ServiceGrid";
export { default as ServiceStepList } from "./ServiceStepList";
export { default as ServicePageLayout } from "./ServicePageLayout";
export { default as ServiceFaq } from "./ServiceFaq";
export { default as ConsultationCTA } from "./ConsultationCTA";
export { default as ServicePageTransition } from "./ServicePageTransition";

// Export animation variants for use in service pages
export {
  serviceContentVariants,
  serviceHeroVariants,
  serviceCardVariants,
} from "./ServicePageTransition";

// Export types for TypeScript support
export type { ServiceFeatureCardProps } from "./ServiceFeatureCard";
export type { ServiceBenefitItemProps } from "./ServiceBenefitItem";
export type { ServiceInfoBoxProps } from "./ServiceInfoBox";
export type { ServiceHeroImageProps } from "./ServiceHeroImage";
export type { ServiceSectionProps } from "./ServiceSection";
export type { ServiceGridProps } from "./ServiceGrid";
export type { ServiceStepListProps } from "./ServiceStepList";
export type { ServicePageLayoutProps } from "./ServicePageLayout";
export type { ServiceFaqProps, ServiceFaqItem } from "./ServiceFaq";
